import { ArrowUpRight } from 'lucide-react'
import { GlowCard, HoldTimer } from '@/components/motion'
import { BetaSignup } from '@/components/BetaSignup'
import type { Product } from '@/data/products'

interface ProductCardProps {
  product: Product
}

export function ProductCard({ product }: ProductCardProps) {
  const Icon = product.icon

  return (
    <GlowCard
      className="product-card"
      style={{ minHeight: '360px', padding: '1.6rem' }}
    >
      <div className="product-card-icon" style={{ background: `${product.color}20`, color: product.color }}>
        <Icon size={22} />
      </div>

      <p className="product-card-audience">{product.audience}</p>
      <h3 className="product-card-name">{product.name}</h3>
      <p className="product-card-tagline">{product.tagline}</p>
      <p className="product-card-scenario">{product.scenario}</p>
      <p className="product-card-description">{product.description}</p>

      <div className="product-card-footer">
        {product.status === 'coming-soon' ? (
          <>
            <span className="product-status-pill">{product.statusDetail ?? 'Coming soon'}</span>
            {product.id === 'reeva' && <BetaSignup source="product-card" />}
            {product.id === 'holdforme' && <HoldTimer />}
            {product.id !== 'reeva' && (
              <a href={product.url} target="_blank" rel="noopener noreferrer" className="product-live-link">
                {product.ctaLabel} <ArrowUpRight size={16} />
              </a>
            )}
          </>
        ) : (
          <a href={product.url} target="_blank" rel="noopener noreferrer" className="product-live-link">
            {product.ctaLabel} <ArrowUpRight size={16} />
          </a>
        )}
      </div>
    </GlowCard>
  )
}
